import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const MenuRouteLink = ({ id, label, Icon, disabled, to, target }) => {
  const renderLink = React.useMemo(
    () => React.forwardRef((itemProps, ref) => <RouterLink to={to} ref={ref} target={target} {...itemProps} />),
    [to, target],
  );

  return (
    <MenuItem button component={renderLink} id={id} disabled={disabled}>
      <ListItemIcon><Icon /></ListItemIcon>
      <ListItemText primary={label} />
    </MenuItem>
  );
};

MenuRouteLink.propTypes = {
  label: PropTypes.string.isRequired,
  Icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({}),
  ]),
  disabled: PropTypes.bool,
  id: PropTypes.string,
  to: PropTypes.string,
  target: PropTypes.string,
};

MenuRouteLink.defaultProps = {
  Icon: undefined,
  disabled: false,
  id: undefined,
  to: undefined,
  target: undefined,
};

export default MenuRouteLink;
